import React, { ReactNode } from 'react';
import { WprDiv } from '../../../wpr-framework/component/controls/WprDiv';
import logo from '../../../../public/images/logo.png';
import peach from '../../../../public/images/peach.png';
import jal from '../../../../public/images/jal.png';
import hankyu from '../../../../public/images/hankyu.png';
import { WprBaseViewComponent } from '../../../wpr-framework/view/component/WprBaseViewComponent';
import { WprContainer } from '../../../wpr-framework/component/controls/WprContainer';
import { WprHeader } from '../../../wpr-framework/component/controls/WprHeader';
import { HeaderComponentView } from './HeaderComponentView';

/**
 * ヘッダーコンポーネント
 */
export class HeaderComponent extends WprBaseViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) { 
		super(new HeaderComponentView(), props); 
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
   * 描画
   */
	public onRender(): ReactNode {
		return (
			<>
				<WprHeader name="headerBorder" view={this.view}>
					<div className="wrap">
						<div className="zurich">
							<span>
								<img className="logo" src={logo} alt="チューリッヒ保険会社" />
								{/*<p className="txt">チューリッヒ保険会社</p>*/}
							</span>
						</div>
						<WprDiv name="agencyCode" view={this.view}>
							<WprContainer mode='peach' view={this.view}><img src={peach} alt="peach" /></WprContainer>
							{/* 20211125 JAL対応 START */}
							<WprContainer mode='jal' view={this.view}><img src={jal} alt="jal" /></WprContainer>
							{/* 20211125 JAL対応 END */}
							{/* WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル） START */}
							<WprContainer mode='hankyu' view={this.view}><img src={hankyu} alt="hankyu" /></WprContainer>
							{/* WRQ-3496_ 【旅行保険】代理店追加対応 阪急交通社(ホワイトラベル） END */}
							<WprContainer mode='default' view={this.view}></WprContainer>
						</WprDiv>
					</div>
				</WprHeader>
			</>
		);
	}
	// --------------------------------------------------------------------------
}